import {
  Button,
  Card,
  Col,
  Form,
  Input,
  Row,
  Select,
  Space,
  Table,
} from "antd";
import { Container } from "react-bootstrap";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { GrView } from "react-icons/gr";
import { useEffect, useState } from "react";
import { API } from "../../config/api";
import { GET, POST } from "../../utils/apicalls";
import PageHeader from "../../admin/pageHeader/pageheader";

const ProjectIndex = () => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [data, setData] = useState<any>([]);
  const [meta, setMeta] = useState<any>({});
  const [selectdata, setselectData] = useState([]);
  const [selectClientData, setselectClientData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();

  const filterProject = async (values: any) => {
    try {
      setIsLoading(true);
      let obj = {
        query: form.getFieldValue("query"),

        projectName: values.projectName,
        clientid: values.clientid,
        assignedTo: values.assignedTo,
        status: true,
      };
      const url = API.PROJECT_FILTERING;
      const response: any = await POST(url, obj);
      setData(response?.data);

      setMeta(response?.meta);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchEmployee = async () => {
    try {
      setIsLoading(true);
      const url = API.EMPLOYEE_LISTING;
      const { data }: any = await GET(url, null);
      setselectData(data);
      console.log(data);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchEmployee();
  }, []);

  const fetchClient = async () => {
    try {
      setIsLoading(true);
      const url = API.CLIENT_LISTING;
      const { data }: any = await GET(url, null);
      setselectClientData(data);
      console.log(data);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchClient();
  }, []);

  const fetchHrproject = async (page: any, take: any) => {
    try {
      setIsLoading(true);
      let obj = {
        query: form.getFieldValue("query"),
        page: page,
        take: 5,
      };
      const url = API.PAGENATION_PROJECT;
      const response: any = await POST(url, obj);
      setData(response?.data);

      setMeta(response?.meta);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchHrproject(page, pageSize);
  }, [page, pageSize]);
  const navigate = useNavigate();

  const columns = [
    {
      dataIndex: "projectName",
      title: "projectName",
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (status: any) => {
        let color = "";

        // Assign colors based on the status value
        switch (status?.toLowerCase()) {
          case "completed":
            color = "green";
            break;
          case "pending":
            color = "orange";
            break;
          case "running":
            color = "blue";
            break;
          case "in-progress":
            color = "purple";
            break;
          default:
            color = "black"; // Default color
        }
        return <span style={{ color, fontWeight: "bold" }}>{status}</span>;
      },
    },
    {
      key: "assignedTo",
      dataIndex: "assignedTo",
      title: "assignedTo",
      render: (_: any, value: any) => <span>{value?.empid?.fullName}</span>,
    },
    {
      dataIndex: "clientid",
      title: "clientid",
      key: "clientid",
      render: (_: any, value: any) => <span>{value?.Client?.companyName}</span>,
    },
    {
      dataIndex: "startDate",
      title: "startDate",
      render: (start_date: any) =>
        start_date ? moment(start_date).format("DD/MM/YYYY") : "-",
    },
    {
      dataIndex: "endDate",
      title: "endDate",
      render: (end_date: any) =>
        end_date ? moment(end_date).format("DD/MM/YYYY") : "-",
    },
    {
      dataIndex: "projectType",
      title: "projectType",
    },
    {
      title: "Action",
      key: "id",
      render: (_: any, record: any) => (
        <Space size="middle">
          <GrView
            color="blue"
            size={20}
            onClick={() =>
              navigate(
                `/Receptionist/Project_Details/view_task_Details/${record?.id}`
              )
            }
          />
        </Space>
      ),
    },
  ];

  return (
    <Container>
      <PageHeader />
      <Card>
        <Form form={form} onFinish={filterProject} layout="vertical">
          <Row gutter={16} align="middle">
            <Col sm={6}>
              <Form.Item name="projectName" label=" projectName">
                <Input placeholder=" projectName" allowClear />
              </Form.Item>
            </Col>

            <Col sm={6}>
              {selectClientData && (
                <Form.Item
                  label="Client Name"
                  name="clientid"
                  style={{ marginBottom: 10 }}
                >
                  <Select
                    placeholder="Select an Client Name"
                    size="large"
                    allowClear
                  >
                    {selectClientData?.map((users: any, i: any) => (
                      <Select.Option key={users?.id} value={Number(users?.id)}>
                        {users?.companyName}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              )}
            </Col>
            <Col sm={6}>
              {selectdata && (
                <Form.Item
                  label="Employee Name"
                  name="assignedTo"
                  style={{ marginBottom: 10 }}
                >
                  <Select
                    placeholder="Select an employee"
                    size="large"
                    allowClear
                  >
                    {selectdata?.map((users: any, i: any) => (
                      <Select.Option key={users?.id} value={Number(users?.id)}>
                        {users?.fullName}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              )}
            </Col>

            <Col sm={6}>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={isLoading}
                  block
                >
                  Search
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
      <br />
      <Card>
        <h1 style={{ textAlign: "center" }}>
          Total {meta?.total_count} Project
        </h1>
        <br />
        <Table
          columns={columns}
          dataSource={data}
          pagination={{
            current: page,
            pageSize: pageSize,
            total: meta?.total_count,
            onChange: (page: any, pageSize: any) => {
              setPage(page);
              setPageSize(pageSize);
            },
          }}
        />
      </Card>
    </Container>
  );
};

export default ProjectIndex;
